<template>
    <v-card v-observe-visibility="visibilityChanged">
        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewManufacturerDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedManufacturer.id === 0">Add New Manufacturer</v-toolbar-title>
            <v-toolbar-title v-else>Edit Manufacturer - {{selectedManufacturer.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-layout row v-if="getNetworkError">
            <v-flex xs12>
                <app-alert @dismissed="onDismissedError" :text="getNetworkError.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-tabs v-model="activeTab"
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>Manufacturer</v-tab>
            <v-tab-item>
                <v-progress-linear class="top-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>General</v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedManufacturer.name"
                                                label="Name">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>Optional Info</v-card-title>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedManufacturer.website"
                                                label="Website">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedManufacturer.email"
                                                label="E-Mail">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout mt-5 row justify-end>
                                    <v-btn :disabled="manufacturerFormEdited" mt-5 color="secondary"
                                           @click.native="saveManufacturer(0)">
                                        Save
                                        <v-icon class="white--text" right>save</v-icon>
                                    </v-btn>
                                </v-layout>

                            </v-flex>

                        </v-layout>


                    </v-container>
                </v-card-text>
            </v-tab-item>


            <v-tab :disabled="branchOfficeTabActive">Branch Offices</v-tab>
            <v-tab-item>
                <manufacturer-branch-offices></manufacturer-branch-offices>
            </v-tab-item>


        </v-tabs>

    </v-card>
</template>


<script>
    import {
        Settings,
        ManufacturersSettings,
        ManufacturerBranchOfficeSettings
    } from '../../store/namespace-helper'

    import manufacturerBranchOffices from '../Settings/Manufacturers/ManufacturerBranchOffices.vue'

    export default {
      components: {
        manufacturerBranchOffices
      },
      name: 'add-new-manufacturer',
      data () {
        return {
          activeTab: 0,
          isVisible: false,
          onDismissed: false,
          manufacturerUpdated: 0
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.manufacturerUpdated = 0
            } else {
              this.manufacturerUpdated = 0
            }
          }
        },
        closeNewManufacturerDialog () {
          this.$store.dispatch(ManufacturersSettings.actions.setSelectedManufacturer, null)
          this.$store.dispatch(ManufacturersSettings.actions.openCloseNewManufacturerDialog)
          this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.resetManufacturersBranchOffices)
          this.activeTab = 0
        },
        saveManufacturer (index) {
          this.$store.dispatch(ManufacturersSettings.actions.saveManufacturers, this.selectedManufacturer)
          this.manufacturerUpdated = 0
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }

      },
      computed: {
        dialog () {
          return this.$store.getters[ManufacturersSettings.getters.getOpenNewManufacturerDialogState]
        },
        selectedManufacturer () {
          console.log('selected manufacturer: ' + JSON.stringify(this.$store.getters[ManufacturersSettings.getters.getSelectedManufacturer]))
          return this.$store.getters[ManufacturersSettings.getters.getSelectedManufacturer]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        branchOfficeTabActive () {
          return this.$store.getters[ManufacturersSettings.getters.getSelectedManufacturer].id === 0
        },
        manufacturerFormEdited () {
          return this.manufacturerUpdated < 1
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        }

      },
      watch: {
        selectedManufacturer: {
          handler (val) {
            console.log('selectedManufacturer data changed: ' + JSON.stringify(val))
            this.manufacturerUpdated++
            console.log('manufacturerUpdated:' + this.manufacturerUpdated)
          },
          deep: true
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .top-loading {
        margin-top: 0px;
    }


</style>


// WEBPACK FOOTER //
// src/components/Shared/AddManufacturer.vue